export const RowState = Object.freeze({
  UNCHANGED: 0,
  ADDED: 1,
  MODIFIED: 2,
  DELETED: 3
});
